module.exports = __webpack_public_path__ + "img/mobile-img-en.692090ac.png";